import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../../_helpers/theming-engine/theme.service';
import { SuccessModalHelperService } from '../../../_helpers/success-modal-helper/success-modal-helper.service';
import { StudentFeedbackService } from '../../../_services/student-feedback/student-feedback.service';
import { SubmitFeedbackResponse } from '../../../_models/student-feedback/submit-feedback-response.model';
import { ErrorModalHelperService } from '../../../_helpers/error-modal-helper/error-modal-helper.service';
import { FeedbackSurvey } from '../../../_models/student-feedback/feedback-survey.model';
import { FeedbackQuestion } from '../../../_models/student-feedback/feedback-question.model';
import { FeedbackAnswer } from '../../../_models/student-feedback/feedback-answer.model';
import { StudentVoiceHelperService } from '../../../_helpers/student-voice-helper/student-voice-helper.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'tuition-feedback',
    templateUrl: './tuition-feedback.component.html',
    styleUrls: ['./tuition-feedback.component.css'],
    standalone: false
})
export class TuitionFeedbackComponent implements OnInit, OnChanges, OnDestroy {
  @Input() studentId: number;
  @Input() placementId: number;
  @Input() placementStartDate: Date;
  @Input() placementEndDate: Date;
  @Input() survey: FeedbackSurvey;
  @Input() showHeader: boolean = true;
  @Input() showSubmit: boolean = true;
  @Output() feedbackSubmitted: EventEmitter<boolean> = new EventEmitter<boolean>();


  public feedbackSurvey: FeedbackSurvey = new FeedbackSurvey();

  public enableUndoButton: boolean = false;
  public disableSubmit: boolean = true;
  
  private ngUnsubscribe = new Subject<void>();

  constructor(
    public themeService: ThemeService,
    private feedbackService: StudentFeedbackService,
    private successModalHelper: SuccessModalHelperService,
    private router: Router,
    private errorModalHelper: ErrorModalHelperService,
    private studentVoiceHelper: StudentVoiceHelperService
    ) {
      this.studentVoiceHelper.modalSubmitTriggered().pipe(takeUntil(this.ngUnsubscribe)).subscribe(triggered => {
        if (triggered) {
          this.submitFeedback();
        }
      })
     }

  ngOnInit() {
    if (this.studentId) {
      this.getQuestionnaireInfo();
    } else {
      this.feedbackSurvey = this.studentVoiceHelper.calculateAnswerIconClass(this.survey);
     
    }
  }

  ngOnChanges(): void {
    if (this.studentId) {
      this.getQuestionnaireInfo();
    } else {
      this.feedbackSurvey = this.studentVoiceHelper.calculateAnswerIconClass(this.survey);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public selectFeedback(question: FeedbackQuestion, answer: FeedbackAnswer,  answerIndex: number): void {
    question.feedbackAnswerData.forEach(a => a.selectedAnswer = null);
    if (question.feedbackAdditionalQuestionData) {
      question.feedbackAdditionalQuestionData.followUpQuestionList.forEach(aq => {
        aq.feedbackAnswerData.forEach(a => a.selectedAnswer = null);
      });
    }

    question.feedbackAnswerData[answerIndex].selectedAnswer = true;

    this.enableUndoButton = true;
    let unansweredQuestionsFound = !this.studentVoiceHelper.checkAllQuestionsAnswered(this.feedbackSurvey);
    this.disableSubmit = unansweredQuestionsFound;
    this.studentVoiceHelper.disableModalSubmit = unansweredQuestionsFound;

    question.showAdditionalQuestions = question.feedbackAdditionalQuestionData && answer.feedbackAnswerValue <= question.feedbackAdditionalQuestionData.triggerOnAnswerLessThan;
  }

  public selectAdditionalFeedback(question: FeedbackQuestion, answerIndex: number): void {
    question.feedbackAnswerData.forEach(a => a.selectedAnswer = null);
    question.feedbackAnswerData[answerIndex].selectedAnswer = true;
    let unansweredQuestionsFound = !this.studentVoiceHelper.checkAllQuestionsAnswered(this.feedbackSurvey);
    this.disableSubmit = unansweredQuestionsFound;
    this.studentVoiceHelper.disableModalSubmit = unansweredQuestionsFound;
  }

  public submitFeedback(): void {
      this.feedbackSurvey.feedbackCompleted = true;
      this.feedbackService.saveFeedback(this.feedbackSurvey).subscribe((response: SubmitFeedbackResponse) => {
        //this.successModalHelper.show("Thank you for your feedback");
        this.feedbackSubmitted.emit(true);
      },
      error => {
        if (error.status === 401) {
          this.router.navigate(['/login']);
        }
        else {
          this.errorModalHelper.show(error.message, error);
        }
      });
  }

  private getQuestionnaireInfo(): void {
    this.feedbackService.requestTuitionFeedbackSurvey(this.studentId, this.placementId, this.placementStartDate, this.placementEndDate).subscribe((result: FeedbackSurvey) => {
      this.feedbackSurvey = this.studentVoiceHelper.calculateAnswerIconClass(result);

    },
    error => {
      if (error.status === 401) {
        this.router.navigate(['/login']);
      }
      else {
        this.errorModalHelper.show(error.message, error);
      }
    });
  }

}
